/* NgRx */

import { createAction, props } from "@ngrx/store";
import { IUser, UserId } from "src/app/interfaces";

export const loadCurrentUser = createAction("[User] Load Current User");
export const loadUser = createAction(
  "[User] Load User",
  props<{ userId: UserId }>()
);

export const loadUserSuccess = createAction(
  "[User] Load User Success",
  props<{ user: IUser }>()
);

export const loadCurrentUserSuccess = createAction(
  "[User] Load Current User Success",
  props<{ user: IUser }>()
);

export const loadCurrentUserFailure = createAction(
  "[User] Load Current User Fail",
  props<{ error: string }>()
);

export const loadUserFailure = createAction(
  "[User] Load User Fail",
  props<{ error: string }>()
);
